module.exports = __webpack_public_path__ + "static/scale-model-of-tillicum-village-in-seattle-washington-35a31bf079c9c4dc0db95609f3615172.png";